import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faBrowser } from '@fortawesome/pro-regular-svg-icons';
import { networks } from '../consts';

const IconMap = {
  [networks.INSTAGRAM_GRAPH]: faInstagram,
  [networks.INSTAGRAM]: faInstagram,
  [networks.YOUTUBE]: faYoutube,
  [networks.TWITTER]: faTwitter,
  [networks.OPEN_GRAPH]: faBrowser,
};

export default function Icon({ icon, className, color, size = 24 }) {
  if (icon === networks.CUSTOM) {
    return <></>;
  }
  if (icon === networks.TIK_TOK) {
    return (
      <FontAwesomeIcon
        icon={['fab', 'tiktok']}
        style={{ fill: color, fontSize: size }}
        className={className}
      />
    );
  }
  return (
    <FontAwesomeIcon
      icon={IconMap[icon]}
      style={{ fill: color, fontSize: size }}
      className={className}
    />
  );
}
